// extracted by mini-css-extract-plugin
export default {"sensor_container":"Style_sensor_container__JjAUl","title":"Style_title__Gbr72","sensor_item_container":"Style_sensor_item_container__YQUMl"};